import type { addWidgetOptions } from '@wix/platform-editor-sdk';
import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

export const addWidget = async (
  editorSDK: FlowEditorSDK,
  options: addWidgetOptions,
) => editorSDK.application.appStudioWidgets.addWidget('', options);
